import { SwitchButton } from '@components/core-ui/form-elements/buttons/Button/variations/SwitchButton';
import { HeaderSwitchWrapper } from '@components/Header/components/HeaderSwitchWrapper';
import { routes } from '@routes';
import { useNavigate } from 'react-router';

type TProps = {
  currentTab: string;
};

export const Tabs = ({ currentTab }: TProps) => {
  const navigate = useNavigate();
  return (
    <HeaderSwitchWrapper key="tabSwitcher">
      <SwitchButton active={currentTab === 'Transactions'} onClick={() => navigate(routes.adminTransactions.make())}>
        Transactions
      </SwitchButton>
      <SwitchButton
        active={currentTab === 'Transaction Codes'}
        onClick={() => navigate(routes.adminTransactionCodesList.make())}
      >
        Transaction Codes
      </SwitchButton>
    </HeaderSwitchWrapper>
  );
};
